"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicNode = void 0;
const react_1 = __importDefault(require("react"));
const text_1 = require("@visx/text");
const shape_1 = require("@visx/shape");
const componentStyle = {
    text: {
        fontSize: "12px",
    },
};
const getColor = (color) => {
    if (color === "green") {
        return { textFill: "#0A6640", pillFill: "#3DCC91" };
    }
    else if (color === "amber") {
        return { textFill: "#A66321", pillFill: "#FFB366" };
    }
    else if (color === "red") {
        return { textFill: "#A82A2A", pillFill: "#FF7373" };
    }
    else {
        return { textFill: "#5C7080", pillFill: "#BFCCD6" };
    }
};
const BasicNode = ({ groupProps, color, id, tooltipData, handleToolTip, hideTooltip, }) => {
    const textY = id.length > 14 ? 35 : 30;
    const textFill = getColor(color).textFill;
    const pillFill = getColor(color).pillFill;
    const pillStroke = getColor(color).textFill;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(shape_1.Bar, { x: "0", y: "0", width: groupProps.width, height: groupProps.height, fill: pillFill, stroke: pillStroke, ry: groupProps.ry, rx: groupProps.rx, onTouchStart: handleToolTip(tooltipData), onTouchMove: handleToolTip(tooltipData), onMouseMove: handleToolTip(tooltipData), onMouseLeave: () => hideTooltip() }),
        react_1.default.createElement(text_1.Text, { width: 20, y: textY, x: 50, textAnchor: "middle", style: componentStyle.text, fill: textFill }, id)));
};
exports.BasicNode = BasicNode;
//# sourceMappingURL=basicNode.js.map